/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "API Supported Endpoints";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="info"><_components.p>{"Chronosphere supports only publicly documented API endpoints. Undocumented, private,\nor experimental API endpoints might change without warning."}</_components.p></Alert>;
}

export default MDXLayout